import { client } from "./client";

export function apiSetBrowserState(stateJson: string) {
  return client.put(
    `/browser_state`,
    { state_json: stateJson }
  );
}

export function apiGetBrowserState() {
  return client.get(
    `/browser_state`
  );
}

